module.exports = __webpack_public_path__ + "static/media/bannerVideoNew2.df0a620.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bannerVideoNew2.mp4
// module id = FcDq
// module chunks = 0